// removed by extract-text-webpack-plugin
module.exports = {"Step3":"Step3","PersonalInfoTitle":"PersonalInfoTitle","InfoPersonal":"InfoPersonal","ProgressBar":"ProgressBar","InfoTitle":"InfoTitle","InfoPleaseTake":"InfoPleaseTake"};


//////////////////
// WEBPACK FOOTER
// ./src/screens/KisEkyc/Step3/style.scss
// module id = 2303
// module chunks = 10